<template>
  <v-container class="px-8 py-5">
    <v-row class="body-2 font-weight-light justify-space-between">
      <div>
        <v-breadcrumbs class="breadcrumbs pa-0" :items="breadcrumbs"></v-breadcrumbs>
      </div>
      <span>{{$todayDate()}}</span>
    </v-row>
    <v-form ref="form">
      <v-row class="justify-center pt-6">
        <v-col cols="12" sm="7">
          <v-row>
            <v-col cols="12" class="pa-0">
              <v-card
                outlined
                class="pa-4"
              >
                <v-row>
                  <v-col cols="4">
                    <v-subheader class="justify-end">Naziv predmeta: </v-subheader>
                  </v-col>
                  <v-col cols="8">
                    <v-text-field
                      outlined
                      hide-details
                      height="44"
                      dense
                      v-model="form.title"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row v-if="$checkPermission('special_subjects add')">
                  <v-col cols="4">
                    <v-subheader class="justify-end">Tip predmeta: </v-subheader>
                  </v-col>
                  <v-col cols="8">
                    <v-autocomplete
                        outlined
                        hide-details
                        height="44"
                        dense
                        item-text="title"
                        item-value="value"
                        :items="types"
                        v-model="form.type"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
                <v-row v-if="$checkPermission('special_subjects add') && form.type !== 0">
                  <v-col cols="4">
                    <v-subheader class="justify-end">Županija/Kanton: </v-subheader>
                  </v-col>
                  <v-col cols="8">
                    <v-autocomplete
                        outlined
                        hide-details
                        height="44"
                        dense
                        item-text="title"
                        item-value="id"
                        :items="cantons"
                        v-model="form.canton_id"
                    ></v-autocomplete>
                  </v-col>
                </v-row>

              </v-card>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" sm="3">
          <v-btn block height="44" class="primary elevation-0 mb-4" @click="updateSubject">Potvrdi</v-btn>
          <v-btn block height="44" outlined class="elevation-0" @click="$router.push('/admin/predmeti')">Odustani</v-btn>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import {serverBus} from "../../main";
import ApiV2 from "@/services/ApiV2";

export default {
  components: {
  },
data: () => ({
    subject: {},
    form: {
      title: '',
      type: 0,
      canton_id: null
    },
  types: [
    {
      title: 'Normalni',
      value: 0
    },
    {
      title: 'Matura/Završni rad',
      value: 1
    },
  ],
  cantons: []

}),
  computed: {
    breadcrumbs() {
      return [
        {
          text: 'Predmeti',
          disabled: false,
          exact: true,
          to: '/admin/predmeti',
        },
        {
          text: this.subject.title,
          disabled: true,
        },
        {
          text: 'Uređivanje',
          disabled: true
        },
      ]
    }
  },
  methods: {
    async getCantons(){
      let {data} = await ApiV2.get('cantons');
      this.cantons = data.data
    },
    getOneSubject() {
      this.$axios.get(`/v2/subjects/${this.$route.params.id}`)
        .then(response => {
          this.subject = response.data;
          this.form.title = response.data.title;
          this.form.type = response.data.type
          this.form.canton_id = response.data.canton_id
        });
    },
    updateSubject(){
      if (!this.$checkPermission('special_subjects add')){
        this.form.canton_id = null
      }
      this.$axios.put(`/v2/subjects/${this.subject.id}`, this.form).then((response) => {
          this.subject = response.data;
          this.$router.go(-1);
          serverBus.$emit('show-snackbar', true, `Uspješno ste ažurirali podatke.`);
        })
        .catch(() => {
          serverBus.$emit('show-snackbar', false);
        });
    },
  },
  mounted() {
    this.getCantons();
    this.getOneSubject();
  }
};
</script>
